export function getOvers(overs) {
    if (overs === "0") {
      return overs;
    }
  
    if (typeof overs !== "string") {
      overs = String(overs);
    }
  
    const [fullOvers, remainingBalls] = overs.split('.').map(parseFloat);
    
    if (remainingBalls < 6) {
      return overs;
    } else {
      return `${fullOvers + 1}.${remainingBalls - 6}`;
    }
  }
  
  export function getDrr(runs, overs) {
    if (overs === "0" && runs === "0") {
      return 0;
    }
  
    if (parseInt(overs) === 0 && parseInt(runs) === 0) {
      return 0;
    }
  
    if (typeof overs !== "string") {
      overs = String(overs);
    }
    
    let [fullOvers, remainingBalls] = overs.split('.').map(parseFloat);
    if(!remainingBalls){
      remainingBalls = 0;
    }
    const decOver = fullOvers + (remainingBalls / 6);
    
    return parseFloat(runs / decOver);
  }
  